function extend(context, key, options) {
  const vessels     = context.$options.vessel || {}
  const extendValue = vessels[key] || {}
  const mergedValue = { ...extendValue, ...options }

  return context.$vessel.apply(mergedValue)
}

export default extend
